// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCQpSignatureServiceRequestEmailSignatureTemplateEmailSignatureTemplateResponse } from './tCQpSignatureServiceRequestEmailSignatureTemplateEmailSignatureTemplateResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SignatureV1EmailSignatureTemplateCreateEnvelopeResponse {
    'data': TCQpSignatureServiceRequestEmailSignatureTemplateEmailSignatureTemplateResponse | null;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SignatureV1EmailSignatureTemplateCreateEnvelopeResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "TCQpSignatureServiceRequestEmailSignatureTemplateEmailSignatureTemplateResponse"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return SignatureV1EmailSignatureTemplateCreateEnvelopeResponse.attributeTypeMap;
    }
}
